/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultModule } from '../../models/api-response-paged-result-module';
import { PagedRequestModule } from '../../models/paged-request-module';

export interface SearchModule$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestModule
}

export function searchModule(http: HttpClient, rootUrl: string, params: SearchModule$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultModule>> {
  const rb = new RequestBuilder(rootUrl, searchModule.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultModule>;
    })
  );
}

searchModule.PATH = '/v1/api/admin-ui/module/search';
